// src/pages/PurchaseAndRefundPolicy.js

import React from 'react';

const PurchaseAndRefundPolicy = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Purchase and Refund Policy</h1>
          </div>
          <br />
          <p><strong>1. Introduction</strong></p>
          <p>Welcome to Sabrenetics. This policy outlines our practices regarding purchases, shipping, and refunds. It is designed to ensure transparency and compliance with Australian Consumer Law.</p>

          <p><strong>2. Purchase Policy</strong></p>
          <p>All purchases made through our website are subject to the following terms:</p>
          <ul>
            <li><strong>Product Availability:</strong> All products listed on our website are subject to availability. We strive to keep our inventory updated, but in the event a product is out of stock, we will notify you as soon as possible.</li>
            <li><strong>Pricing and Payment:</strong> Prices displayed on our website are in AUD and include GST. We accept various payment methods, including credit card, PayPal, and other secure payment gateways.</li>
            <li><strong>Order Confirmation:</strong> Once your order is placed, you will receive an order confirmation email detailing your purchase. This email serves as proof of your transaction.</li>
            <li><strong>Processing Time:</strong> Orders are processed within 1-2 business days. Delivery times are estimated based on your location and chosen shipping method.</li>
          </ul>

          <p><strong>3. Shipping Policy</strong></p>
          <p>We aim to deliver your purchases promptly. Our shipping policy includes:</p>
          <ul>
            <li><strong>Shipping Methods:</strong> We offer various shipping options, including standard, express, and international shipping. Delivery times and costs vary by location and shipping method.</li>
            <li><strong>Shipping Costs:</strong> Shipping costs are calculated at checkout based on your location and the shipping method selected. We offer free shipping on orders over a specified amount.</li>
            <li><strong>Delivery Times:</strong> Estimated delivery times are provided at checkout. These are approximate and may vary due to factors beyond our control, such as weather conditions or customs delays.</li>
            <li><strong>Tracking Information:</strong> Once your order is shipped, you will receive a tracking number via email, allowing you to monitor your shipment’s progress.</li>
          </ul>

          <p><strong>4. Refund and Return Policy</strong></p>
          <p>Our refund and return policy is designed to comply with Australian Consumer Law. Please review the following guidelines:</p>
          <ul>
            <li><strong>Change of Mind:</strong> We do not accept returns for change of mind. Please choose carefully before making a purchase.</li>
            <li><strong>Faulty or Damaged Goods:</strong> If you receive a faulty or damaged item, please contact us within 14 days of receiving your order. We will provide a full refund, replacement, or repair as per Australian Consumer Law.</li>
            <li><strong>Incorrect Items:</strong> If you receive an incorrect item, please contact us within 14 days. We will arrange for a return and dispatch the correct item at no additional cost to you.</li>
            <li><strong>Return Process:</strong> To initiate a return, please contact our customer service team with your order number and reason for return. We will provide you with instructions on how to return the item. Items must be returned in their original condition, including packaging and tags.</li>
            <li><strong>Refund Processing:</strong> Refunds will be processed within 7-10 business days of receiving the returned item. The refund will be issued to the original payment method used for the purchase.</li>
          </ul>

          <p><strong>5. Contact Us</strong></p>
          <p>If you have any questions or concerns regarding our Purchase, Shipping, and Refund Policy, please contact us:</p>
          <p>
            Email: support@sabrenetics.com<br />
            Trading name: Sabrenetics<br />
            Address: B1/13-21 Mandible St Alexandria NSW 2015, Australia<br />
            Phone number: 0433 546 300<br />
            ACN: 655 184 946<br />
            ABN: 89 655 184 946<br />
            Business Registration number: 89 655 184 946<br />
          </p>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default PurchaseAndRefundPolicy;
